<!-- <app-loader *ngIf="isLoading"></app-loader>
<app-popover [mergerModal]="true" (closeCallback)="cancelCallback()" size="merge-booking" titleText="Merge Booking" [fullHeight]="true">
  <div popover-header class="steps-container">
    <div class="steps">
      <app-stepper [activeStep]="activeStep" [steps]="stepperDetails" (stepChangeCallback)="onStepClick($event)"
        [formArray]="stepperFormArray"></app-stepper>
    </div>
  </div>
  <div style="border: 1px solid #E0E0E0;"></div>
  <div popover-content class="merge-content">
    <form [formGroup]="formDetails" *ngIf="formDetails">
      <div *ngIf="activeStep == 0">
        <app-merge-booking-details (showBookingDetails)="showBookingDetails($event)" [bookings]="bookings"
          [formDetails]="formDetails.get('bookingDetails')" [config]="bookingFormConfig"></app-merge-booking-details>
      </div>
      <div *ngIf="activeStep == 1">
        <app-merge-rider-details [bookings]="bookings" [formArray]="formDetails.get('stopsArray')"
          [config]="riderFormConfig" [riderMap]="riderMap"
          [bookingDetails]="formDetails.get('bookingDetails').getRawValue()"
          [bookingForm]="formDetails.get('bookingDetails')"></app-merge-rider-details>
      </div>
      <div *ngIf="activeStep == 2">
        <app-requester-details [requester]="mergedRequestData.bookingRequest.requester"
          [paymentType]="mergedRequestData.bookingRequest.spotBookings[0].paymentType"></app-requester-details>
        <app-payee-details *ngIf="mergedRequestData.bookingRequest.payer"
          [payee]="mergedRequestData.bookingRequest.payer"
          [paymentType]="mergedRequestData.bookingRequest.spotBookings[0].paymentType"></app-payee-details>
        <app-booking-details [booking]="mergedRequestData.bookingRequest.spotBookings[0]"></app-booking-details>
      </div>
    </form>
  </div>
  <div popover-actions class="actions-wrapper">
    <app-button (clickCallback)="onStepChange(0)" *ngIf="activeStep == 1" class="mr-10" type="plainText" text="Back">
    </app-button>
    <app-button (clickCallback)="onStepChange(1)" *ngIf="activeStep == 2" class="mr-10" type="plainText" text="Back">
    </app-button>
    <app-button (clickCallback)="goToRiderDetails()" *ngIf="activeStep == 0" type="primaryFilled" text="Next">
    </app-button>
    <app-button (clickCallback)="goToConfirmRequest()" *ngIf="activeStep == 1" type="primaryFilled" text="Next">
    </app-button>
    <app-button (clickCallback)="onSubmitClick()" *ngIf="activeStep == 2" type="primaryFilled" text="Merge">
    </app-button>
  </div>
</app-popover>

<app-booking-details-popover *ngIf="isBookingDetailsVisible && singleBookingDetails"
  [singleBookingDetails]="singleBookingDetails" (closeBookingDetailsCallback)="handleCloseBookingDetails()">
</app-booking-details-popover>

<app-dialog *ngIf="mergerFailed" type="alert" [buttonText]="['Okay']" [titleText]="'Error'"
                (approveCallback)="mergerFailed=false;cancelCallback()">
                {{mergerError}}
              </app-dialog> -->
<app-loader *ngIf="isLoading"></app-loader>
<app-popover [mergerModal]="true" (closeCallback)="cancelCallback()" size="merge-booking" titleText="Merge Bookings" [fullHeight]="true">
  <div popover-header class="steps-container displayFlexRow fs-20">
    <div class="steps">
      <app-stepper [activeStep]="activeStep" [steps]="stepperDetails"
        [formArray]="stepperFormArray"></app-stepper>
    </div>
    <div class="cancelBooking" (click)="cancelMergeBooking=true">
      Cancel Booking
    </div>
  </div>

  <div popover-content class="merge-content">
    <form [formGroup]="formDetails" *ngIf="formDetails">
      <div *ngIf="activeStep == 0">
        <app-merge-booking-details (showBookingDetails)="showBookingDetails($event)" [bookings]="bookings"
          [formDetails]="formDetails.get('bookingDetails')" [config]="bookingFormConfig" [miscelleneousConfig]="miscelleneousConfig"></app-merge-booking-details>
      </div>
      <div *ngIf="activeStep == 1">
        <app-merge-rider-details [bookings]="bookings" [formArray]="formDetails.get('stopsArray')"
          [config]="riderFormConfig" [riderMap]="riderMap"
          [bookingDetails]="formDetails.get('bookingDetails').getRawValue()"
          [bookingForm]="formDetails.get('bookingDetails')" [miscelleneousConfig]="miscelleneousConfig"></app-merge-rider-details>
      </div>
      <div *ngIf="activeStep == 2" class="ml-24">
        <div class="line" ></div>
        <app-confirm-booking-details  [booking]="mergedRequestData.bookingRequest.spotBookings[0]"
    [requester]="mergedRequestData.bookingRequest.requester" [bookingsList]="mergedRequestData.bookingRequest.spotBookings"></app-confirm-booking-details>
      </div>
    </form>
   
  </div>
  <div popover-actions class="actions-wrapper">
    <app-button (clickCallback)="onStepChange(0)" *ngIf="activeStep == 1" class="mr-10" type="plainText" text="Back">
    </app-button>
    <app-button (clickCallback)="onStepChange(1)" *ngIf="activeStep == 2" class="mr-10" type="plainText" text="Back">
    </app-button>
    <app-button (clickCallback)="goToRiderDetails()" *ngIf="activeStep == 0" type="primaryFilled" text="Next">
    </app-button>
    <app-button (clickCallback)="goToConfirmRequest()" *ngIf="activeStep == 1" type="primaryFilled" text="Next">
    </app-button>
    <app-button (clickCallback)="onSubmitClick()" *ngIf="activeStep == 2" type="primaryFilled" text="Merge">
    </app-button>
  </div>
</app-popover>

<app-dialog
  *ngIf="cancelMergeBooking"
  titleText="Confirm"
  type="confirm"
  [buttonText]="['Yes', 'No']"
  (approveCallback)="cancelCallback();cancelMergeBooking=false"
  (dismissCallback)="cancelMergeBooking=false"
  (closeCallback)="cancelMergeBooking=false"
  [icon]="false"
  src="assets/ic-ui-warning-24.svg"
>
Any changes you have made will be lost. Are you sure you want to leave?
              </app-dialog>